import React__default from 'react';

var DropdownContext = /*#__PURE__*/React__default.createContext({
  onSelect: function onSelect() {
    return undefined;
  },
  value: null,
  items: [],
  searchString: ""
});

export default DropdownContext;
//# sourceMappingURL=context.js.map
